<div class="ui full-width card">
    <img src="{{brand.logo}}" class="brand-logo margin-top-30 margin-bottom-10">
    <h2>{{brand.name}}</h2>
    <p class="moto">{{brand.moto}}</p>
    <div class="ui two column stackable grid brand">
        <div class="column">
            <button class="ui button" (click)="websiteCliked()">Site de la marque</button>
        </div>
        <div class="column">
            <button class="ui button" (click)="configuratorCliked()">Configurateur</button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/new-car/presentation/brand/brand.html